





















































import { Component, Mixins, Watch } from 'vue-property-decorator'
import DexieService from '@/services/dexie-service'
import SnackbarService from '@/services/snackbar-service'
import AuthService from '@/services/auth-service'
@Component({
  components: {},
})
export default class EditMainUserDialog extends Mixins(
  DexieService,
  SnackbarService,
  AuthService
) {
  editUsernameDialogIsOpen = false
  editPasswordDialogIsOpen = false
  username = ''
  password = ''
  triedSendPassword = false;

  created() {
    this.setEmptyUsername()
    this.setEmptyPassword()
  }
  @Watch('editUsernameDialogIsOpen')
  setEmptyUsername() {
    this.username = ''
  }

  @Watch('editPasswordDialogIsOpen')
  setEmptyPassword() {
    this.password = ''
  }

  updateUsername() {
    this.sendUpdateUsername(this.username).then((res: any) => {
      this.editUsernameDialogIsOpen = false
      this.notify({ text: 'Username updated successfully', type:'success' })
      this.$store.state.user.username = this.username
    })
  }

  updatePassword(){
    this.triedSendPassword = true
    if (this.password.length < 4) {
        return
    }
    this.sendUpdatePassword(this.password).then((res: any) => {
      this.editPasswordDialogIsOpen = false
      this.notify({ text: 'Password updated successfully', type:'success' })
    })
  }
}
